import { useNavigation } from "react-router";

// clientAction への送信が「API を叩く段階」で進行中かを返す。
// - action 実行中 (`submitting`) に加え、action 完了後のリダイレクト / 再検証 (`loading` だが formMethod を保持) も含める。
//   保存ボタンを押してから次の画面が出るまでを一続きの「処理中」として扱うため。
// - 2 段階サブミットの confirm 段階 (`submitType=confirm`) はバリデーションのみで API を叩かないため除外する。
// - GET 遷移 (formMethod なし / GET) は対象外。
export const useNavigationPending = (): boolean => {
    const navigation = useNavigation();
    if (navigation.state === "idle") return false;
    if (!navigation.formMethod || navigation.formMethod === "GET") return false;

    const submitType = navigation.formData?.get("submitType");
    return submitType === null || submitType === undefined || submitType === "submit";
};
